import styled from 'styled-components';

export const HeaderPage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const ActionsPage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FilterStatus = styled.div`
  width: 100%;
  min-height: 30px;
  border-bottom: 1px solid #d7dce0;
  margin: 35px 0;
`;

export const ButtonFilterStatus = styled.button`
  height: 40px;
  text-align: left;
  font: normal normal 600 16px/22px Source Sans Pro;
  color: #959595;

  border: none;
  background-color: transparent;
  padding: 1px 0;

  margin-right: 25px;
  border-bottom: ${(props) =>
    props.selected ? '2px solid var(--color-blue-primary)' : ''};
  cursor: pointer;

  :last-child {
    margin-right: 0px;
  }

  :hover {
    color: var(--color-gray-100);
    border-bottom: 2px solid var(--color-blue-primary);
  }
`;

export const FilterActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  height: 40px;
  width: 100%;
  margin-bottom: 33px;
`;
